import { useSearchParams } from 'react-router-dom';
import { normalizeColor } from '../helpers/colors';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  return {
    user: searchParams.get('user') || '',
    bg: searchParams.get('bg') || null,
    phoneNumber,
    title: searchParams.get('title'),
    socials: searchParams.get('socials'),
    qrCode: searchParams.get('qrCode'),
    cols: searchParams.get('cols') || 3,
    phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || '4.8',
    titleFontSize: searchParams.get('titleFontSize') || '4.8',
    sizeQR: searchParams.get('sizeQR') || '20',
    paddingQR: searchParams.get('paddingQR') || '0',
    authorFontSize: searchParams.get('authorFontSize') || '3.2',
    msgFontSize: searchParams.get('msgFontSize') || '2.5',

    clrBgAdvt:
      normalizeColor(searchParams.get('clrBgAdvt')) || 'rgba(0,0,0,0.8)',
    clrTextAdvt:
      normalizeColor(searchParams.get('clrTextAdvt')) || 'rgba(255,255,255,1)',
  };
};
